import { Divider, MessageBar, MessageBarBody } from '@fluentui/react-components';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ClientOnboardingForm } from '../../../api';
import { useMpmProjectTemplateOptionsGet, useStaffOptionsGet } from '../../../api/hooks/OptionsApi';
import { MpmProject, MpmSection } from '../../../types/MpmTypes';
import Stack from '../../layout/Stack';
import MpmProjectEntryRow from '../MpmProjectEntryRow';
import MpmProjectsTable from '../MpmProjectsTable';

type MpmFormValues = ClientOnboardingForm & { mpmSection: MpmSection };

const MpmCard = () => {
    const { control, watch } = useFormContext<MpmFormValues>();
    const yearEnd = watch('adminSection.yearEnd');
    const { fields, append, remove } = useFieldArray({ control, name: 'mpmSection.projects' });

    const { data: templateOptions, isLoading: templateLoading, isFetched: templateFetched } = useMpmProjectTemplateOptionsGet();
    const { data: staffOptions, isLoading: staffLoading, isFetched: staffFetched } = useStaffOptionsGet();

    const templateOptionsLoaded = !templateLoading && templateFetched;
    const staffOptionsLoaded = !staffLoading && staffFetched;

    const handleAdd = (project: MpmProject) => {
        append(project);
    };

    return (
        <>
            <Stack flexDirection="column" alignItems="stretch">
                <MpmProjectEntryRow
                    key={fields.length}
                    onAdd={handleAdd}
                    templateOptions={templateOptions ?? []}
                    templateOptionsLoaded={templateOptionsLoaded}
                    staffOptions={staffOptions ?? []}
                    staffOptionsLoaded={staffOptionsLoaded}
                    yearEnd={yearEnd}
                />
                {fields.length > 0 ? (
                    <>
                        <Divider />
                        <MpmProjectsTable projects={fields as MpmProject[]} onRemove={remove} />
                    </>
                ) : (
                    <MessageBar intent="warning">
                        <MessageBarBody>Add at least one project — ModernPM clients require one.</MessageBarBody>
                    </MessageBar>
                )}
            </Stack>
        </>
    );
};

export default MpmCard;
